<template>
  <div id="Landing" data-app>
    <MarketingApplicationDialog
      class="dialog-cccc"
      :userData="{ user }"
      :is-application-dialog-open="isApplicationDialogOpen"
      @close-application-dialog="closeApplicationDialog"
      @close="isApplicationDialogOpen = false"
      v-if="isApplicationDialogOpen"
    />
    <BannerSection/>
    <MainSection/>
    <InfoSection/>
    <FooterBannerSection/>
    <PreProductsSection/>
    <ButtonSection
      @open-application-dialog="openApplicationDialog"
    />
    <SectionFooter/>
  </div>
</template>
<script>
import BannerSection from './components/BannerSection'
import MainSection from './components/MainSection'
import InfoSection from './components/InfoSection'
import PreProductsSection from './components/PreProductsSection'
import FooterBannerSection from './components/FooterBannerSection'
import ButtonSection from './components/ButtonSection'
import MarketingApplicationDialog from './components/MarketingApplicationDialog'
import AuthService from '@/service/auth/AuthService'
import ChannelService from '@/service/channeltalk/ChannelService'
import SectionFooter from './components/SectionFooter'
// import SectionFooter from '@/views/main/components/SectionFooter'

const CONNECT_SERVICE = '마케팅론'

export default {
  name: 'Landing',
  components: {
    BannerSection,
    MainSection,
    InfoSection,
    FooterBannerSection,
    PreProductsSection,
    ButtonSection,
    MarketingApplicationDialog,
    SectionFooter,
  },
  data: function () {
    return {
      user: {
        connect_service: CONNECT_SERVICE,
        utm_source: this.getUrlParameter('utm_source'),
        utm_medium: this.getUrlParameter('utm_medium'),
        utm_campaign: this.getUrlParameter('utm_campaign'),
      },
      isApplicationDialogOpen: false,
    }
  },
  async created() {
    document.title = CONNECT_SERVICE
    ChannelService.shutdown()
    let obj = await AuthService.getProfile()
    if (obj) {
      Object.assign(this.user, obj)
    }
    ChannelService.shutdown()
  },
  methods: {
    openApplicationDialog(isApplicationDialogOpen) {
      this.isApplicationDialogOpen = isApplicationDialogOpen
    },
    closeApplicationDialog(isApplicationDialogOpen) {
      this.isApplicationDialogOpen = isApplicationDialogOpen
    },
    getUrlParameter(sParam) {
      let uri = window.location.search.substring(1)
      let params = new URLSearchParams(uri)
      return params.get(sParam)
    }
  }
}
</script>
<style lang="scss" scoped>
  #Landing {
    left: 100px;
  }
  .custom-dialog {
    // border-radius: 14px;
    background-color: red;
    left: 100px;
  }
</style>
